//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { IInstagramUsedHashtag } from '@apis/instagram-hashtags-usage/instagramHashtagsUsageApiModels';
import DateString from '@models/DateString';
import TimeZoneId from '@models/TimeZoneId';
import { groupBy } from '@utils/groupBy';

export const isWithinLastWeek = (date: Date) => {
  return DateString.isWithin(DateString.fromTimestamp(date, TimeZoneId.Utc), {
    minDate: DateString.addDays(DateString.getToday(TimeZoneId.Utc), -7),
    maxDate: DateString.getToday(TimeZoneId.Utc),
  });
};

/**
 * Determines if a hashtag should count toward the tracking limit.
 *
 * A hashtag counts toward the limit if:
 * - It is currently tracked (isTracked: true), OR
 * - It is not tracked but has no endDate (used elsewhere), OR
 * - It was untracked within the last 7 days (grace period)
 *
 * A hashtag does NOT count if:
 * - It is not tracked AND has an endDate more than 7 days ago
 */
export const shouldCountTowardLimit = (
  hashtag: IInstagramUsedHashtag,
): boolean => {
  if (hashtag.isTracked) {
    return true;
  }
  if (!hashtag.endDate) {
    return true;
  }
  return isWithinLastWeek(hashtag.endDate);
};

export const groupHashtagsByRecentActivity = (
  hashtags: IInstagramUsedHashtag[],
) => {
  return groupBy(hashtags, (hashtag) => {
    return hashtag.endDate ? isWithinLastWeek(hashtag.endDate) : false;
  });
};
